import React, { useState, useEffect } from "react";

const TerminalBootSequence = ({ onComplete }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [currentLine, setCurrentLine] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  const bootLines = [
    "DeveloperNoob OS v0.4.4 booting...",
    "Loading kernel modules... [OK]",
    "Initializing coffee dependency... [OK]",
    "Mounting /dev/imposter-syndrome... [WARNING]",
    "Starting CSS confidence service... [FAILED]",
    "Retrying CSS confidence service... [23% SUCCESS]",
    "Loading JavaScript anxiety handler... [LOADING...]",
    "Checking Stack Overflow connection... [OK]",
    "Initializing frontend courage module... [PARTIAL]",
    "Loading NodeJs Worker... [LOADING...]",
    "Starting developer humor engine... [OK]",
    "System ready. Welcome to the Noob World!",
  ];

  useEffect(() => {
    if (currentLine < bootLines?.length) {
      const timer = setTimeout(() => {
        setCurrentLine((prev) => prev + 1);
      }, Math.random() * 500 + 300);
      return () => clearTimeout(timer);
    } else if (!isComplete) {
      const completeTimer = setTimeout(() => {
        setIsComplete(true);
      }, 1000);
      return () => clearTimeout(completeTimer);
    }
  }, [currentLine, bootLines.length, isComplete]);

  // Add keyboard listener after boot completes
  useEffect(() => {
    if (!isComplete) return;

    // Keyboard handler for desktop
    const handleKeyPress = () => onComplete?.();

    // Touch handler for mobile
    const handleTouch = () => onComplete?.();

    window.addEventListener("keydown", handleKeyPress);
    window.addEventListener("touchstart", handleTouch);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("touchstart", handleTouch);
    };
  }, [isComplete, onComplete]);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    setIsMobile(/android|iphone|ipad|iPod|mobile/i.test(userAgent));
  }, []);

  return (
    <div className="fixed inset-0 bg-background z-50 flex items-center justify-center">
      <div className="w-full max-w-2xl p-4 sm:p-8">
        <div className="bg-card border border-terminal rounded-lg p-4 sm:p-6 terminal-glow font-fira text-sm">
          <div className="flex items-center mb-4">
            <div className="w-3 h-3 bg-destructive rounded-full mr-2"></div>
            <div className="w-3 h-3 bg-warning rounded-full mr-2"></div>
            <div className="w-3 h-3 bg-success rounded-full mr-2"></div>
            {/* <span className="text-muted-foreground ml-2">
              Terminal - Loading.....
            </span> */}
          </div>

          <div className="space-y-1">
            {bootLines?.slice(0, currentLine)?.map((line, index) => (
              <div key={index} className="flex items-center">
                <span className="text-terminal-cyan mr-2">$</span>
                <span
                  className={`
                  ${line?.includes("[OK]") ? "text-success" : ""}
                  ${line?.includes("[FAILED]") ? "text-destructive" : ""}
                  ${line?.includes("[WARNING]") ? "text-warning" : ""}
                  ${line?.includes("[LOADING...]") ? "text-terminal-cyan" : ""}
                  ${!line?.includes("[") ? "text-foreground" : ""}
           `}
                >
                  {line}
                </span>
                {index === currentLine - 1 && (
                  <span className="ml-1 animate-pulse text-primary">|</span>
                )}
              </div>
            ))}
          </div>

          {isComplete && (
            <div className="mt-4 text-center">
              <div className="text-primary animate-pulse">
                {isMobile
                  ? "Tap anywhere to continue..."
                  : "Press any key to continue..."}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TerminalBootSequence;
